import { Element } from "slate";
import { Slate } from "@makeswift/controls";
function isLinkEntry(inline) {
  return Slate.isInline(inline[0]) && Element.isElementType(inline[0], Slate.InlineType.Link);
}
export {
  isLinkEntry
};
//# sourceMappingURL=types.js.map